@if (homeLink(); as link) {
  <a
    class="app-brand-link"
    [class.app-brand-link--isotype]="variant === 'isotype'"
    [routerLink]="link"
    [attr.aria-label]="brandWordmark"
  >
    @if (variant === 'isotype') {
      <img
        [src]="isotypeBlackSrc"
        class="app-isotype app-isotype--light"
        width="32"
        height="32"
        alt=""
        aria-hidden="true"
      />
      <img
        [src]="isotypeWhiteSrc"
        class="app-isotype app-isotype--dark"
        width="32"
        height="32"
        alt=""
        aria-hidden="true"
      />
    } @else {
      <img
        [src]="brandLogoSrc"
        class="app-brand-logo app-brand-logo--light"
        alt=""
        aria-hidden="true"
      />
      <img
        [src]="brandLogoWhiteSrc"
        class="app-brand-logo app-brand-logo--dark"
        alt=""
        aria-hidden="true"
      />
    }
  </a>
} @else {
  <span
    class="app-brand-link"
    [class.app-brand-link--isotype]="variant === 'isotype'"
    [attr.aria-label]="brandWordmark"
  >
    @if (variant === 'isotype') {
      <img
        [src]="isotypeBlackSrc"
        class="app-isotype app-isotype--light"
        width="32"
        height="32"
        alt=""
        aria-hidden="true"
      />
      <img
        [src]="isotypeWhiteSrc"
        class="app-isotype app-isotype--dark"
        width="32"
        height="32"
        alt=""
        aria-hidden="true"
      />
    } @else {
      <img
        [src]="brandLogoSrc"
        class="app-brand-logo app-brand-logo--light"
        alt=""
        aria-hidden="true"
      />
      <img
        [src]="brandLogoWhiteSrc"
        class="app-brand-logo app-brand-logo--dark"
        alt=""
        aria-hidden="true"
      />
    }
  </span>
}
